<!-- =========================================================================================
    File Name: Recommend.vue
    Description: Price Optimization Recommendation
    ----------------------------------------------------------------------------------------
    Item Name: Appyvue - Bootstrap App with PY and VUE
    Author: @nand
========================================================================================== -->
<template>
  <div id="sku-forecast">
    <!-- <pre>{{unitSelected}}</pre> -->
    <trend-mock :artefact="artefact" type="category" :key="unitSelected"></trend-mock>
    <div class="vx-row">
      <div class="vx-col w-full" id="order-panel">
        <vx-card
          title="Product Portfolio - SKUs">
          <template slot="actions">
          </template>
          <!-- TABLE ACTION ROW -->
          <div class="flex flex-wrap justify-between items-center">
            <!-- ITEMS PER PAGE -->
            <div class="mb-4 md:mr-4 ag-grid-table-actions-left">
              <vs-dropdown vs-trigger-click class="cursor-pointer">
                <div
                  class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
                >
                  <span
                    class="mr-2"
                  >{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ units.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : units.length }} of {{ units.length }}</span>
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>
                <!-- <vs-button class="btn-drop" type="filled" color="primary" icon-pack="feather" icon="icon-chevron-down">{{paginationPageSize > 0 ? paginationPageSize : stock.res.order.length}} per page</vs-button> -->
                <vs-dropdown-menu>
                  <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                    <span>10</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                    <span>20</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="gridApi.paginationSetPageSize(50)">
                    <span>50</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="gridApi.paginationSetPageSize(100)">
                    <span>100</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="gridApi.paginationSetPageSize(150)">
                    <span>150</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>

            <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
            <div class="flex flex-wrap items-center justify-between ag-grid-table-actions-right">
              <!-- <vx-tooltip
                title="Preset Rules"
                color="warning"
                text="1. Select all skus with order quantity greater than 12 units.">

                <vs-button size="small" :color="ruleFilter.state === 'apply' ? 'primary' : 'gray'" class="mb-4 md:mb-0 mr-4" @click="actOnFilter(ruleFilter.state, '0', 'recommend_price')">{{ruleFilter.label}}</vs-button>
              </vx-tooltip> -->
              <vs-input-number class="mb-4 md:mb-0 mr-6" v-model="serviceLevel.actual" :step="serviceLevel.step" :min="serviceLevel.min" :max="serviceLevel.max" :color="serviceLevel.intensity" :label="serviceLevel.label" @input="applyServiceLevel()"/>
              <vs-button class="mb-4 md:mb-0 mr-4" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button>
              <vs-button class="mb-4 md:mb-0 mr-4" @click="exportToExcel()">Export as XSLX</vs-button>
              <vs-button class="mb-4 md:mb-0 mr-4" @click="approve()">Approve & Capture</vs-button>
              
              <!-- <vs-button
                class="mb-4 md:mb-0"
                @click="popupActive=true;"
              >Order - <small> {{ orderValue | numFormat('$ 0,0') }} </small> -->
              <!-- <span class="feather-icon-badge bg-primary text-white h-5 w-5 absolute rounded-full text-xs flex items-center justify-center">{{unitSelected.length}}</span> -->
              <!-- </vs-button> -->
              <!-- <vs-chip color="danger" v-if="unitSelected.length > 0" class="bg-danger text-white absolute text-xs flex items-center justify-center" style="top: 15px; right: 10px">{{ unitSelected.length }}</vs-chip> -->
              <!-- <vs-chip color="danger" v-if="unitSelected.length > 0">{{ unitSelected.length }}</vs-chip> -->
              <!-- <feather-icon icon="ShoppingCartIcon" class="cursor-pointer ml-4 mr-6 mt-1" :badge="unitSelected.length"></feather-icon> -->
            </div>
          </div>
          <!-- <div class="flex flex-wrap justify-between items-center">
              <vs-input
                  class="w-full"
                  v-model="searchQuery"
                  @input="updateSearchQuery"
                  placeholder="Search..."
                />
            
          </div> -->
          <ag-grid-vue
            :gridOptions="gridOptions"
            class="ag-theme-material w-100 my-4 ag-grid-table"
            :columnDefs="columnDefs"
            :defaultColDef="defaultColDef"
            :rowData="units"
            rowSelection="multiple"
            colResizeDefault="shift"
            :animateRows="true"
            :floatingFilter="true"
            :pagination="true"
            :paginationPageSize="paginationPageSize"
            :suppressPaginationPanel="true"
            @grid-ready="onGridReady"
            @selection-changed="onSelectionChanged"
            @column-value-changed="onOverride"
          ></ag-grid-vue>
          <vs-pagination :total="totalPages" :max="maxPageNumbers" v-model="currentPage" />
        </vx-card>
      </div>
    </div>
<!-- 
    <div class="flex flex-wrap justify-between mr-5">
      <div></div>

      <vs-button
        @click="popupActive=true;$vs.notify({title:'Success',text:'Stock Order details notified to the resepective department',color:'success'})"
        color="primary"
        type="filled"
      >Trigger Stock Order</vs-button>
    </div> 
-->
    <sku-insight :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" :data="sidebarData" :artefact="artefact"/>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import VueApexCharts from "vue-apexcharts";
import StatisticsCardLine from "@/app/shared/components/statistics-cards/StatisticsCardLine.vue";
import analyticsData from "./analyticsData.js";
import { AgGridVue } from "ag-grid-vue";
import SkuInsight from './SkuInsight.vue'
import TrendMock from "./TrendMock.vue";

export default {
  props: {
    artefact: { type: Object, required: true }
  },
  data() {
    return {
      orderValue: 0,
      override: false,
      serviceLevel: {
        label: "Service Level (%): ",
        default: 100,
        actual: 100,
        min: 40,
        max: 160,
        step: 5,
        intensity: "primary",
        index: 1
      },
      ruleFilter: {
        label: 'Apply Rule',
        state: 'apply'
      },
      searchQuery: "",
      gridOptions: {},
      maxPageNumbers: 7,
      gridApi: null,
      gridColumnApi: null,
      defaultColDef: {
        sortable: true,
        editable: false,
        resizable: true,
        suppressMenu: true
      },
      columnDefs: [
        {
          headerName: "",
          field: "row",
          filter: false,
          width: 20,
          pinned: "left",
          // checkboxSelection: true,
          // headerCheckboxSelectionFilteredOnly: true,
          // headerCheckboxSelection: true
        },
        {
          headerName: "Channel",
          field: "store_code",
          filter: true,
          filterParams: {
            clearButton: true,
            applyButton: true,
            debounceMs: 200
          },
          width: 150,
          unSortIcon: true,
          pinned: "left",
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
          hide: true
        },
        {
          headerName: "SKU Id",
          field: "sku_id",
          filter: true,
          filterParams: {
            clearButton: true,
            applyButton: true,
            debounceMs: 200
          },
          // unSortIcon: true,
          pinned: "left",
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
          width: 200,
        },
        {
          headerName: "Description",
          field: "long_description",
          filter: "agTextColumnFilter",
          filterParams: {
            clearButton: true,
            applyButton: true,
            debounceMs: 200
          },
          width: 300,
          // unSortIcon: true,
          // pinned: "left",
          // checkboxSelection: true,
          // headerCheckboxSelectionFilteredOnly: true,
          // headerCheckboxSelection: true,
          // cellRenderer: (params) => {
          //     // console.log(params.data);
          //     return "<span style='color:#b8c2cc'><small>"+params.data.sku_id+ " / </small></span>" + params.value;
          // }
        },
                {
          headerName: "Price ( "+this.$options.filters.currencySymbol('')+" )",
          field: "price",
          filter: "agNumberColumnFilter",
          filterParams: {
            clearButton: true,
            applyButton: true,
            debounceMs: 200
          },
          // sort: "desc",
          // unSortIcon: true,
          width: 120
        },
        {
          headerName: "Mkt. Price ( "+this.$options.filters.currencySymbol('')+" )",
          field: "best_price",
          filter: true,
          // filterParams: {
          //   clearButton: true,
          //   applyButton: true,
          //   debounceMs: 200
          // },
          // sort: "desc",
          // unSortIcon: true,
          width: 170
        },
        {
          headerName: "Optimal ( "+this.$options.filters.currencySymbol('')+" )",
          field: "recommend_price",
          filter: "agNumberColumnFilter",
          filterParams: {
            clearButton: true,
            applyButton: true,
            debounceMs: 200
          },
          // sort: "desc",
          // unSortIcon: true,
          width: 150
        },
        {
          headerName: "Override",
          field: "oqty",
          width: 120,
          filter: "agNumberColumnFilter",
          filterParams: {
            clearButton: true,
            applyButton: true,
            debounceMs: 200
          },
          // unSortIcon: true,
          editable: true
        },
        {
          headerName: "Change %",
          field: "odiff",
          filter: "agNumberColumnFilter",
          filterParams: {
            clearButton: true,
            applyButton: true,
            debounceMs: 200
          },
          sort: "desc",
          width: 150,
          // unSortIcon: true,
        },
        {
          headerName: "In Hand ( # )",
          field: "stock_qty",
          filter: true,
          // unSortIcon: true,
          width: 140
        },
        {
          headerName: "Est. Rev  ( "+this.$options.filters.currencySymbol('')+" )",
          field: "revenue_sum",
          filter: true,
          // unSortIcon: true,
          width: 150
        },
        {
          headerName: "Est. Sale ( # )",
          field: "sold_qty",
          filter: true,
          // unSortIcon: true,
          width: 150
        }        
      ],


      analyticsData: analyticsData,
      showStatsPanel: true,
      popupActive: false,
      colorx: "#e1e1e1",

      unitSelected: [],
      tableList: [
        "vs-th: Component",
        "vs-tr: Component",
        "vs-td: Component",
        "thread: Slot",
        "tbody: Slot",
        "header: Slot"
      ],
      units: [],


      //Export Feature
      fileName: "PO Trigger @ "+this.$options.filters.dateFormat(new Date(), 'D MMM YYYY'),
      formats:["xlsx", "csv", "txt"] ,
      cellAutoWidth: true,
      selectedFormat: "xlsx",
      headerTitle: ["Row", "Channel", "SKU Id","SKU", "Category", "Brand", "Order", "Override Qty.", "Ctc"],
      headerVal: ["row", "store_code", "sku_id","long_description", "product_category", "brand", "recommend_price", "oqty", "revenue_sum"],


      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {},
    };
  },
  watch: {
    "$store.state.windowWidth"(val) {
      if (val <= 576) {
        this.maxPageNumbers = 4;
        this.gridOptions.columnApi.setColumnPinned("code", null);
      } else this.gridOptions.columnApi.setColumnPinned("code", "left");
    }
  },
  computed: {
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 50;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      }
    },

    ...mapGetters({ order: "optimizer/artefact" })
  },
  methods: {
    onGridReady(params) {
      this.gridApi = params.api;
      this.columnApi = params.columnApi;

      this.gridApi.paginationSetPageSize(10);
    },
    onSelectionChanged() {
        const selectedNodes = this.gridApi.getSelectedNodes();
        const selectedData = selectedNodes.map( node => node.data );
        this.unitSelected = selectedData;
        this.orderValue = this.unitSelected.map(x => x.revenue_sum).reduce(function(a, b){
                return a + b;
            }, 0);
        
        let oqty = (this.unitSelected[0].recommend_price !== this.unitSelected[0].oqty) ? this.unitSelected[0].oqty : Math.ceil(this.unitSelected[0].recommend_price * this.serviceLevel.index);
        let odiff = ((this.unitSelected[0].recommend_price - oqty)/this.unitSelected[0].recommend_price)*(-100);

        this.unitSelected[0].oqty = oqty < 0 ? 0 : oqty;
        this.unitSelected[0].odiff = odiff;
        // this.orderValue = 0;//Math.floor(Math.random() * 101010101);
        // const selectedDataStringPresentation = selectedData.map( node => node.long_description + ' ' + node.product_category).join(', ');
        // alert(`Selected nodes: ${selectedDataStringPresentation}`);
        if(selectedNodes && selectedNodes.length > 0){
          this.editData(selectedData)
        } else {
          this.toggleDataSidebar(false)
        }

    },
    actOnFilter(type, query, prop) {
      if(type !== 'refresh') {
        this.ruleFilter.state = type !== 'clear' ? 'clear' : 'apply';
        this.ruleFilter.label = type !== 'clear' ? 'Clear Rule' : 'Apply Rule';
      }

      if(type === 'apply' || (this.ruleFilter.state === 'clear' && type === 'refresh')) {
        
        var filterInstance = this.gridApi.getFilterInstance(prop);

        // number filter with one condition, with greaterThanOrEqual type
        var numberGreaterThanOrEqual = {
            filterType: 'number',
            type: 'greaterThanOrEqual',
            filter: 12
        };

        // set filter model and update
        filterInstance.setModel(numberGreaterThanOrEqual);

        // tell the grid to refresh rows based on the filter. The filter does
        // not do this automatically, allowing you to batch multiple filter
        // updates for performance
        this.gridApi.onFilterChanged();
        this.gridApi.selectAllFiltered();
      } else if(type === 'clear') {
        this.gridApi.deselectAllFiltered();
      }
      this.gridApi.destroyFilter(prop);
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
    },
    formatStoreOrder() {
      this.units = [];

      for (let i = 0; i < this.artefact.tags.length; i++) {
        let eachfilterAndSortData = this.filterAndSortData(
          this.artefact.tags[i],
          this.order.res.order
        );

        for (let j = 0; j < eachfilterAndSortData.length; j++) {
          let demandSkus = {};
          Object.assign(demandSkus, eachfilterAndSortData[j]);

          // let oqty = (demandSkus.recommend_price !== demandSkus.oqty) ? demandSkus.oqty : Math.ceil(demandSkus.recommend_price * this.serviceLevel.index);
          // let odiff = ((demandSkus.recommend_price - oqty)/demandSkus.recommend_price)*(-100);
          let oqty = Math.ceil(demandSkus.recommend_price * this.serviceLevel.index);
          let odiff = ((demandSkus.recommend_price - oqty)/demandSkus.recommend_price)*(-100);

          demandSkus.oqty = oqty < 0 ? 0 : oqty;
          demandSkus.odiff = odiff;
          // if (eachfilterAndSortData[j].oqty > 11) {
          //   this.handleSelected(eachfilterAndSortData[j]);
          // }
          this.units.push(demandSkus);
        }
      }
      this.actOnFilter('clear', '0', 'recommend_price');
      // this.artefact.res.refresh = [];
    },
    filterAndSortData(tag, data) {
      // console.log('filterAndSortData -> ', tag.tag, data[0]);

      // let filteredData = data;

      let filteredData = data.filter(
        t => tag.code === t.store_code || tag.tag === t.product_category
        // t => (t.store_code ? (tag.code === t.store_code) : (tag.tag === t.product_category))
      );

      return filteredData.sort(function(t1, t2) {
        return t2.recommend_price - t1.recommend_price;
      });
    },
    updateItemQuantity(event, index, tr) {
      // const itemIndex = Math.abs(index + 1);
      tr.oqty = event;
      tr.odiff = (tr.recommend_price - tr.oqty)/tr.recommend_price

      this.handleSelected(tr);
      // if(!this.unitSelected.includes(tr) && (this.units[index].recommend_price !== this.units[index].oqty)) {
      //   this.unitSelected.push(this.units[index]);
      // } else if(this.unitSelected.includes(tr) && (this.units[index].recommend_price === this.units[index].oqty)) {
      //   this.unitSelected.splice(index, index+1);
      // }
    },
    showOverrideIndicator(data) {
      if (Number(data.oqty) !== Number(data.recommend_price)) {
        if (Number(data.oqty) > Number(data.recommend_price)) {
          return "success";
        } else {
          return "warning";
        }
      } else {
        return "primary";
      }
    },
    handleSelected(tr) {
      let selectedUnitIndex = this.findIndex(
        this.unitSelected,
        ["store_code", "sku_id"],
        tr
      );
      if (selectedUnitIndex < 0) {
        this.unitSelected.push(tr);
      } else if (selectedUnitIndex > -1 && tr.recommend_price !== tr.oqty) {
        this.unitSelected.splice(selectedUnitIndex, 1);
        this.unitSelected.push(tr);
      } else if (selectedUnitIndex > -1 && tr.recommend_price === tr.oqty) {
        this.unitSelected.splice(selectedUnitIndex, 1);
      }
    },
    applyState(tr, indextr) {
      return this.findIndex(this.unitSelected, ["store_code", "sku_id"], tr) >
        -1 || tr.recommend_price !== tr.oqty
        ? "warning"
        : "";
    },
    findIndex(arr, keys, val) {
      return arr.findIndex(v => this.findMatch(v, keys, val));
    },
    findMatch(obj, keys, val) {
      let flag = true;
      for (var i = 0; i < keys.length; i++) {
        if (flag) {
          flag = obj[keys[i]] === val[keys[i]];
        } else {
          return false;
        }
      }

      return flag;
    },

    activatePopup() {
      if(this.popupActive) {
        return this.unitSelected;
      } else {
        return [];
      }
    },

    exportToExcel() {
      import('@/plugins/Export2Excel').then(excel => {
        const list = this.unitSelected
        const data = this.formatJson(this.headerVal, list)
        excel.export_json_to_excel({
          header: this.headerTitle,
          data,
          filename: this.fileName,
          autoWidth: this.cellAutoWidth,
          bookType: this.selectedFormat
        })
        this.clearFields()
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        // Add col name which needs to be translated
        // if (j === 'timestamp') {
        //   return parseTime(v[j])
        // } else {
        //   return v[j]
        // }

        return v[j]
      }))
    },
    clearFields() {
      this.fileName = ""
      this.cellAutoWidth = true
      this.selectedFormat = "xlsx"
    },
    applyServiceLevel() {
      /*
      this.$vs.loading({
        // background: this.backgroundLoading,
        // color: this.colorLoading,
        container: "#order-panel",
        // scale: 0.45,
        type: "radius"
      });
      */


      this.serviceLevel.intensity = "primary";
      if(this.serviceLevel.actual > this.serviceLevel.default) {
        this.serviceLevel.intensity = "danger";
      } else if(this.serviceLevel.actual < this.serviceLevel.default) {
        this.serviceLevel.intensity = "warning";
      }

      this.serviceLevel.index = (Number(this.serviceLevel.actual) + (Number(this.serviceLevel.actual) - this.serviceLevel.default))/ 100;

      this.formatStoreOrder();

      // this.$vs.loading.close("#order-panel > .con-vs-loading");

    },
    
    addNewData() {
      this.sidebarData = {}
      this.toggleDataSidebar(true)
    },
    deleteData(id) {
      this.$store.dispatch("dataList/removeItem", id).catch(err => { console.error(err) })
    },
    editData(data) {
      // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
      this.sidebarData = data
      this.toggleDataSidebar(true)
    },
    toggleDataSidebar(val=false) {
      this.addNewDataSidebar = val
    },

    approve() {
      this.$vs.notify({
          title: 'Price Optimization',
          text: 'Price Recommendation appoved!',
          color: 'success'
        })
    }
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
    this.gridColumnApi = this.gridOptions.columnApi;
    this.formatStoreOrder();
  },
  components: {
    AgGridVue,
    VueApexCharts,
    StatisticsCardLine,
    SkuInsight,
    TrendMock
  }
};
</script>

<style lang="scss">
  @import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
</style>
